import { useMemo, useEffect } from 'react';
import { useSnackbar } from 'notistack';
import { useApi } from 'hooks/api';
import { TYPE } from 'utils/alerts';
import { fetchGlobalInfo } from 'api/info';

const OutageNotice = () => {
  const { enqueueSnackbar } = useSnackbar();

  const { data } = useApi(fetchGlobalInfo);

  const notices = useMemo(() => {
    if (!Array.isArray(data)) return [];

    return data.reduce((acc, cur) => {
      if (!!cur.outageNotice && !cur.isResolved) {
        acc.push(cur.outageNotice);
      }

      return acc;
    }, []);
  }, [data]);

  useEffect(() => {
    notices.forEach(notice => {
      enqueueSnackbar(notice, {
        variant: TYPE.WARNING,
        persist: true,
        preventDuplicate: true,
      });
    });
  }, [notices, enqueueSnackbar]);

  return null;
};

export default OutageNotice;
